import styled from 'styled-components';

const BlackText = styled.div`
  color: var(--grey700);
  font-size: 12px;
`;
export default BlackText;
